export default __webpack_public_path__ + "static/media/abed.b591700d.jpg";